<template>
  <v-layout class="full-height-container" justify-center align-center>
    <v-layout class="form-container">
      <div class="form">
        <div v-show="true">
          <h2 v-if="currentIdentity">
            Hi,
            <span class="ph-no-capture">{{ currentIdentity.full_name }}</span>
          </h2>

          <div class="text-xs-left py-2 body-1">
            <div class="pb-2">
              Before continuing, we need to first verify your identity. You'll
              be asked to complete the following steps:
            </div>
            <ul class="pl-4 pb-2">
              <li>
                Take a photo of a government-issued ID (such as a driver's
                license)
              </li>
              <li>Take a quick selfie to confirm it's really you</li>
            </ul>
            <div class="pb-2">
              This process typically takes less than 2 minutes.
            </div>
          </div>

          <v-btn
            block
            large
            color="primary"
            class="mt-3 text-none"
            :loading="loading"
            @click="createVerificationSession"
          >
            <b>Start Identity Verification</b>
          </v-btn>

          <v-btn
            flat
            block
            color="secondary"
            class="text-none mt-2"
            @click="$emit('back')"
          >
            <v-icon small class="mr-2">arrow_back</v-icon>
            Go back
          </v-btn>
        </div>

        <div v-show="false">
          Thank you for completing the identity verification.
        </div>
      </div>
    </v-layout>
  </v-layout>
</template>

<script src="https://js.stripe.com/v3/"></script>
<script>
import axios from 'axios';

export default {
  data() {
    return {
      loading: false,
    };
  },
  props: {
    currentIdentity: {
      type: Object,
      default: () => {},
    },
    taxReturnId: {
      required: true,
    },
  },
  created() {
    this.stripe = Stripe(process.env.STRIPE_PUBLISHABLE_KEY);
  },
  methods: {
    async createVerificationSession() {
      this.loading = true;
      const response = axios
        .post('stripe_identity_verifications', {
          tax_return_id: this.taxReturnId,
        })
        .then(response => {
          return this.stripe.verifyIdentity(response.data.client_secret);
        })
        .then(result => {
          if (result.error) {
            this.$store.dispatch('application/setErrorNotification', {
              message: result.error.message,
            });
          } else {
            this.$emit('identity-verified', true);
          }
        })
        .catch(error => {
          console.error('Error:', error);
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>

<style lang="postcss" scoped>
.full-height-container {
  height: 100vh;
}

.form-container {
  max-width: 400px;
  border-radius: 4px;
  box-shadow: 0 1px 3px rgba(0 0 0 / 25%);
  background-color: white;
}

.form {
  padding: 12px 16px;

  & >>> h2 {
    padding: 10px 0px;
  }

  & >>> .v-input__slot {
    height: 44px;
  }
}
</style>
